"use client"
import { AxisModel, BarSeries, Category, ChartComponent, DataLabel, dragStart, Inject, Legend, ScrollBar, SeriesCollectionDirective, SeriesDirective, Tooltip, Zoom, ZoomSettingsModel } from "@syncfusion/ej2-react-charts";
import { useEffect, useState } from "react";

interface StatBarChartProps {
    data: {x: string, y: number}[],
    palettes: string[],
    primaryxAxis: AxisModel,
    primaryyAxis: AxisModel,
    title: string,
    rowHeight?:number,
    getHeight?: (length: number) => number

}
export const StatsBarChart: React.FC<StatBarChartProps> = ({data, palettes, primaryxAxis, primaryyAxis, title, getHeight, rowHeight}) => {
    const marker = { visible: true, dataLabel: { visible: true } };
    const calcHeight = () => getHeight?getHeight(data.length):data.length*(rowHeight??50);
    const [height, setHeight] = useState(calcHeight());
    useEffect(()=>{
      //Force rebuild to readjust height
      setHeight(0);
      setHeight(calcHeight());
    }, [data, rowHeight])
    if (height === 0) return <div></div>
    return <ChartComponent
        //Add legends height
        height={(height + 45).toString()}
        primaryXAxis={primaryxAxis}
        primaryYAxis={primaryyAxis}
        title={title}
        palettes={palettes}>
    <Inject services={[Legend, BarSeries, Tooltip, DataLabel, Category ]}/>
    <SeriesCollectionDirective>
      <SeriesDirective dataSource={data} xName='x' yName='y' type='Bar' marker={marker}>
      </SeriesDirective>
    </SeriesCollectionDirective>
  </ChartComponent>;
}